import React from 'react';
import Icon from '../../../components/AppIcon';

const PaymentStatisticsCard = ({ statistics }) => {
  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6">
      <h3 className="text-lg font-bold text-foreground mb-4">Payment Statistics</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="bg-success/10 rounded-lg p-4 border border-success/20">
          <div className="flex items-center justify-between mb-2">
            <Icon name="CheckCircle" size={20} className="text-success" />
            <span className="text-2xl font-bold text-foreground">{statistics?.paidInvoices || 0}</span>
          </div>
          <p className="text-sm text-muted-foreground">Paid Invoices</p>
        </div>

        <div className="bg-warning/10 rounded-lg p-4 border border-warning/20">
          <div className="flex items-center justify-between mb-2">
            <Icon name="Clock" size={20} className="text-warning" />
            <span className="text-2xl font-bold text-foreground">{statistics?.pendingInvoices || 0}</span>
          </div>
          <p className="text-sm text-muted-foreground">Pending Invoices</p>
        </div>

        <div className="bg-error/10 rounded-lg p-4 border border-error/20">
          <div className="flex items-center justify-between mb-2">
            <Icon name="AlertCircle" size={20} className="text-error" />
            <span className="text-2xl font-bold text-foreground">{statistics?.overdueInvoices || 0}</span>
          </div>
          <p className="text-sm text-muted-foreground">Overdue Invoices</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-primary/5 rounded-lg p-4 border border-primary/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Total Spent</span>
            <Icon name="DollarSign" size={18} className="text-primary" />
          </div>
          <p className="text-2xl font-bold text-foreground">K{statistics?.totalSpent?.toFixed(2) || '0.00'}</p>
        </div>

        <div className="bg-secondary/5 rounded-lg p-4 border border-secondary/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Avg Monthly Spend</span>
            <Icon name="TrendingUp" size={18} className="text-secondary" />
          </div>
          <p className="text-2xl font-bold text-foreground">K{statistics?.averageMonthlySpend?.toFixed(2) || '0.00'}</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentStatisticsCard;